import { ApiClient } from 'ApiClient';
import { Reservation, ReservationStatus } from 'interfaces';

class ReservationService {
  public async getAll(query?: {
    status?: ReservationStatus;
    date?: string;
    search?: string;
  }): Promise<Reservation[]> {
    const params: { [key: string]: string | number } = {};
    if (query?.status) params.status = query.status;
    if (query?.date) params.date = query.date;
    if (query?.search) params.search = query.search;
    return ApiClient.get<Reservation[]>('reservations', params);
  }

  public async getById(id: number): Promise<Reservation> {
    return ApiClient.get<Reservation>(`reservations/${id}`);
  }

  public create(data: any) {
    return ApiClient.post('reservations', data);
  }

  public update(id: number, data: any) {
    return ApiClient.put(`reservations/${id}`, data);
  }

  public remove(id: number) {
    return ApiClient.delete(`reservations/${id}`);
  }

  public async getAvailability(
    date: string,
    experienceId?: number,
  ): Promise<{ date: string; slots: string[]; reason?: string }> {
    const params: { [key: string]: string | number } = { date };
    if (experienceId) params.experience_id = experienceId;
    return ApiClient.get<{ date: string; slots: string[]; reason?: string }>(
      'reservations/availability',
      params,
    );
  }
}

const singleton = new ReservationService();
export { singleton as ReservationService };
